
import { useBotData } from './use-bot-data';
import { useBotActions } from './use-bot-actions';
import { useState } from 'react';

export const useBotDetail = (botId: string | undefined) => {
  const { bot, connectedAccounts, isLoading, error } = useBotData(botId);
  const { 
    toggleBotStatus, 
    deleteBot, 
    isDeleting, 
    onToggleAccountConnection, 
    onDeleteAccount,
    accountActionError
  } = useBotActions(botId);
  
  const [isDisconnectedDialogOpen, setIsDisconnectedDialogOpen] = useState(false);
  const [disconnectedCspAccountId, setDisconnectedCspAccountId] = useState<string | undefined>(undefined);

  // Handle CTrader disconnected errors from account actions
  if (
    accountActionError?.code === 'P0001' && 
    accountActionError.message.includes('disconnected in the Ctrader Profile') &&
    !isDisconnectedDialogOpen
  ) {
    // Extract the CSP account ID from the connectedAccounts based on the error
    const account = connectedAccounts.find(acc => acc.id === accountActionError.accountId);
    if (account?.api_connection?.csp_account_id) {
      setDisconnectedCspAccountId(account.api_connection.csp_account_id);
      setIsDisconnectedDialogOpen(true);
    }
  }
  
  return {
    bot,
    isLoading,
    error,
    connectedAccounts,
    toggleBotStatus: () => toggleBotStatus(bot),
    deleteBot: () => deleteBot(bot),
    isDeleting,
    onToggleAccountConnection,
    onDeleteAccount,
    disconnectedCspAccountId,
    isDisconnectedDialogOpen,
    setIsDisconnectedDialogOpen
  };
};
